import React, { useCallback, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { DDMMYYYYFormat, formatNumber } from "../../../common/Misc";
import { API, fileUpload } from "../../../../config";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import Spin from "../../../common/Spin";
// import NumberFormat from "react-number-format";

const ProgressPaymentItem = ({ contractId, handleExport, onDataPass }) => {
  const [variationData, setVariationData] = useState();
  const [summaryData, setSummaryData] = useState();
  const [loading, setLoading] = useState(false);
  // const [portionInput, setPortionInput] = useState();
  const params = useParams();
  const projectId = params?.project_id;

  const variationColumns = [
    {
      dataField: "name",
      text: "Name",
      style: {
        width: "100px",
      },
    },
    {
      dataField: "original_value_exc",
      text: "Original Value(Ex)",
    },
    {
      dataField: "variation_amount",
      text: "Variation Value(Ex)",
    },
    {
      dataField: "contract_value_exc",
      text: "New Contract Value(Ex)",
    },
    {
      dataField: "contract_value",
      text: "New Contract Value(Inc)",
    },
    // {
    //   dataField: "cumulative_claim",
    //   text: "Cumulative Claim(Ex)",
    // },
    // {
    //   dataField: "actual_paid",
    //   text: "Actual Paid(Inc)",
    // },
    // {
    //   dataField: "outstanding_payable",
    //   text: "Outstanding Payable(Inc)",
    // },
    // {
    //   dataField: "work_remaining",
    //   text: "Work Remaining(Inc)",
    // },
    // {
    //   dataField: "retention_percentage",
    //   text: "Retention(%)",
    // },
    // {
    //   dataField: "retained_amount",
    //   text: "Retained Amount",
    // },
  ];

  const varationDataGenerator = (quantity) => {
    const items = [];
    let totalCumulativeTotal = 0;
    let totalActualPaid = 0;
    let totalOutstandingPayable = 0;
    let totalWorkRemaining = 0;
    let totalRetainedAmount = 0;
    let retention_percentage = 0;

    for (let i = 0; i < quantity; i++) {
      totalCumulativeTotal =
        totalCumulativeTotal +
        (variationData[i]?.cumulative_claim
          ? variationData[i]?.cumulative_claim
          : 0);

      totalActualPaid =
        totalActualPaid +
        (variationData[i]?.actual_paid ? variationData[i]?.actual_paid : 0);

      totalOutstandingPayable =
        totalOutstandingPayable +
        (variationData[i]?.outstanding_payable
          ? variationData[i]?.outstanding_payable
          : 0);

      if (quantity - 1 === i) {
        totalWorkRemaining =
          variationData[i]?.contract_value - totalActualPaid;

        retention_percentage = variationData[i]?.retention_percentage
          ? `${variationData[i]?.retention_percentage}%`
          : "0%";
      }
      // totalWorkRemaining =
      //   totalWorkRemaining +
      //   (variationData[i]?.work_remaining
      //     ? variationData[i]?.work_remaining
      //     : 0);

      totalRetainedAmount =
        totalRetainedAmount +
        (variationData[i]?.retained_amount
          ? variationData[i]?.retained_amount
          : 0);

      items.push({
        key: variationData[i]?.id,
        original_value_exc: variationData[i]?.original_value_exc
          ? `$${formatNumber(Number(variationData[i]?.original_value_exc))}`
          : "-",
        name:
          variationData[i]?.count === 0
            ? "Original"
            : variationData[i]?.count
            ? `Variation ${variationData[i]?.count}`
            : "-",
        variation_amount: variationData[i]?.amount ? (
          <span
            className={
              variationData[i]?.transaction_type ? "rag-green" : "rag-red"
            }
          >
            {`$${formatNumber(Number(variationData[i]?.amount / 1.1))}
                        `}
          </span>
        ) : (
          "$0.00"
        ),
        retained_amount: variationData[i]?.retained_amount
          ? variationData[i]?.retained_amount < 0
            ? `($${formatNumber(
                Math.abs(Number(variationData[i]?.retained_amount))
              )})`
            : `$${formatNumber(
                Math.abs(Number(variationData[i]?.retained_amount))
              )}`
          : "$0.00",
        retention_percentage: variationData[i]?.retention_percentage
          ? `${variationData[i]?.retention_percentage}%`
          : "0%",
        contract_value_exc: variationData[i]?.contract_value_exc
          ? `$${formatNumber(Number(variationData[i]?.contract_value_exc))}`
          : "$0.00",
        contract_value: variationData[i]?.contract_value
          ? `$${formatNumber(Number(variationData[i]?.contract_value))}`
          : "$0.00",
        actual_paid: variationData[i]?.actual_paid
          ? variationData[i]?.actual_paid < 0
            ? `($${formatNumber(
                Math.abs(Number(variationData[i]?.actual_paid))
              )})`
            : `$${formatNumber(
                Math.abs(Number(variationData[i]?.actual_paid))
              )}`
          : "$0.00",
        work_remaining: variationData[i]?.work_remaining
          ? variationData[i]?.work_remaining < 0
            ? `($${formatNumber(
                Math.abs(Number(variationData[i]?.work_remaining))
              )})`
            : `$${formatNumber(
                Math.abs(Number(variationData[i]?.work_remaining))
              )}`
          : "$0.00",
        cumulative_claim: variationData[i]?.cumulative_claim
          ? variationData[i]?.cumulative_claim < 0
            ? `($${formatNumber(
                Math.abs(Number(variationData[i]?.cumulative_claim))
              )})`
            : `$${formatNumber(
                Math.abs(Number(variationData[i]?.cumulative_claim))
              )}`
          : "$0.00",
        outstanding_payable: variationData[i]?.outstanding_payable
          ? variationData[i]?.outstanding_payable < 0
            ? `($${formatNumber(
                Math.abs(Number(variationData[i]?.outstanding_payable))
              )})`
            : `$${formatNumber(
                Math.abs(Number(variationData[i]?.outstanding_payable))
              )}`
          : "$0.00",
      });
    }
    items.push({
      // name: <b>Total</b>,
      cumulative_claim: (
        <>
          {totalCumulativeTotal
            ? totalCumulativeTotal < 0
              ? `($${formatNumber(Math.abs(Number(totalCumulativeTotal)))})`
              : `$${formatNumber(Math.abs(Number(totalCumulativeTotal)))}`
            : "$0.00"}
        </>
      ),
      actual_paid: (
        <>
          {totalActualPaid
            ? totalActualPaid < 0
              ? `($${formatNumber(Math.abs(Number(totalActualPaid)))})`
              : `$${formatNumber(Math.abs(Number(totalActualPaid)))}`
            : "$0.00"}
        </>
      ),
      work_remaining: (
        <>
          {totalWorkRemaining
            ? totalWorkRemaining < 0
              ? `($${formatNumber(Math.abs(Number(totalWorkRemaining)))})`
              : `$${formatNumber(Math.abs(Number(totalWorkRemaining)))}`
            : "$0.00"}
        </>
      ),
      retention_percentage: (
        <>{retention_percentage ? `${retention_percentage}` : "0%"}</>
      ),
      outstanding_payable: (
        <>
          {totalOutstandingPayable
            ? totalOutstandingPayable < 0
              ? `($${formatNumber(Math.abs(Number(totalOutstandingPayable)))})`
              : `$${formatNumber(Math.abs(Number(totalOutstandingPayable)))}`
            : "$0.00"}
        </>
      ),
      retained_amount: (
        <>
          {totalRetainedAmount
            ? totalRetainedAmount < 0
              ? `($${formatNumber(Math.abs(Number(totalRetainedAmount)))})`
              : `$${formatNumber(Math.abs(Number(totalRetainedAmount)))}`
            : "$0.00"}
        </>
      ),
    });
    return items;
  };
  const variationDatas = varationDataGenerator(variationData?.length);

  const summaryDataColumns =
    // Number(portionInput?.replace("%", "")) !== 0
    //   ? [
    //       {
    //         dataField: "contract_number",
    //         text: "Contract Number",
    //         headerClasses: "fixed-header fixed-column",
    //         classes: "fixed-column",
    //         style: {
    //           width: "115px",
    //         },
    //       },
    //       {
    //         dataField: "claim_against",
    //         text: "Claim Against",
    //         headerClasses: "fixed-header fixed-column",
    //         classes: "fixed-column",
    //         style: {
    //           width: "120px",
    //         },
    //       },
    //       {
    //         dataField: "invoice_number",
    //         text: "Invoice Number",
    //         headerClasses: "fixed-header fixed-column",
    //         classes: "fixed-column",
    //         style: {
    //           width: "110px",
    //         },
    //       },
    //       {
    //         dataField: "invoice_date",
    //         text: "Invoice Date",
    //         headerClasses: "fixed-header fixed-column",
    //         classes: "fixed-column",
    //         style: {
    //           width: "100px",
    //         },
    //       },
    //       {
    //         dataField: "cummulative_claim",
    //         text: "Cummulative Claim To Date",
    //       },
    //       {
    //         dataField: "progress_last_month",
    //         text: "Progress Up To Last Month",
    //       },
    //       {
    //         dataField: "certificate_amount",
    //         text: "Current Certificate Amount",
    //       },
    //       {
    //         dataField: "payable_amount_ex_gst",
    //         text: "Payable Amount Before GST",
    //       },
    //       {
    //         dataField: "gst",
    //         text: "GST",
    //       },
    //       {
    //         dataField: "payable_amount",
    //         text: "Net Payable After GST",
    //       },
    //       {
    //         dataField: "portion_pay",
    //         text: "Portion To Pay",
    //       },
    //       {
    //         dataField: "portion_pay_ex_gst",
    //         text: "Portion (Ex.)",
    //       },
    //       {
    //         dataField: "portion_pay",
    //         text: "Act Amt. Invoiced (Inc.)",
    //       },
    //       {
    //         dataField: "claim_invoice_variance",
    //         text: "Claim to Invoice Variance",
    //       },
    //       {
    //         dataField: "paid_per_treasury",
    //         text: "Paid per treasury (Inc.)",
    //       },
    //       {
    //         dataField: "outstanding_payable",
    //         text: "Outstanding Payable",
    //       },
    //     ]
    // :
    [
      {
        dataField: "invoice_number",
        text: "Invoice Number",
        headerClasses: "fixed-header fixed-column",
        classes: "fixed-column",
        style: {
          width: "110px",
        },
      },
      {
        dataField: "invoice_date",
        text: "Invoice Date",
        headerClasses: "fixed-header fixed-column",
        classes: "fixed-column",
        style: {
          width: "100px",
        },
      },
      {
        dataField: "cummulative_claim",
        text: "Cumulative Claim(Ex)",
      },
      {
        dataField: "progress_last_month",
        text: "Progress Upto Last Month(Ex)",
      },
      {
        dataField: "certificate_amount",
        text: "Current Month(Ex)",
      },
      {
        dataField: "payable_amount_ex_gst",
        text: "Payable(Ex)",
      },
      {
        dataField: "gst",
        text: "GST",
      },
      {
        dataField: "payable_amount",
        text: "Payable(Inc)",
      },
      {
        dataField: "paid_per_treasury",
        text: "Paid(Inc)",
      },
      {
        dataField: "outstanding_payable",
        text: "Outstanding Payable(Inc)",
      },
    ];

  const fetchProgressPaymentSummaryReport = useCallback(
    async (id, portionData) => {
      if (id) {
        try {
          setLoading(true);
          const formData = new FormData();
          formData.append("builder_project_id", projectId);
          formData.append("contracts[0]", id);
          // if (portionData) {
          //   formData.append("partnership_percentage", portionData);
          // }
          const { data } = await fileUpload(
            `${API.CONTRACT_SUMMARY_REPORT}`,
            formData
          );
          let reportData = data?.data[0];

          onDataPass(contractId, reportData);

          setVariationData(
            reportData?.variations ? reportData?.variations : []
          );
          setSummaryData(reportData?.summary ? reportData?.summary : []);
          setLoading(false);
        } catch (error) {
          if (error?.response?.data?.errors) {
            setLoading(false);
            Object.keys(error?.response?.data?.errors).forEach((key) => {
              toast.error(error?.response?.data?.errors[key][0]);
            });
          } else {
            setLoading(false);
            toast.error(error?.message);
          }
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [projectId]
  );

  useEffect(() => {
    fetchProgressPaymentSummaryReport(contractId);
  }, [contractId, fetchProgressPaymentSummaryReport]);

  // const handlePortionBlur = (portionData) => {
  //   fetchProgressPaymentSummaryReport(
  //     contractId,
  //     portionData?.replace("%", "")
  //   );
  // };

  const summaryDataGenerator = (quantity) => {
    const items = [];
    // let totalContractValueExGST = 0;

    let totalCumulativeClaim = 0;
    let totalProUpToLastMonth = 0;
    let totalCertificateAmount = 0;
    let totalBeforeGST = 0;
    let totalGST = 0;
    let totalClaimAmount = 0;
    let totalPaidPerTreasury = 0;
    let totalOutstandingPayable = 0;

    for (let i = 0; i < quantity; i++) {
      totalCumulativeClaim =
        totalCumulativeClaim +
        (summaryData[i]?.cumulativeClaim
          ? Number(summaryData[i]?.cumulativeClaim)
          : 0);
      totalProUpToLastMonth =
        totalProUpToLastMonth +
        (summaryData[i]?.proUpToLastMonth
          ? Number(summaryData[i]?.proUpToLastMonth)
          : 0);
      totalCertificateAmount =
        totalCertificateAmount +
        (summaryData[i]?.currentAmount
          ? Number(summaryData[i]?.currentAmount)
          : 0);
      totalBeforeGST =
        totalBeforeGST +
        (summaryData[i]?.beforeGST ? Number(summaryData[i]?.beforeGST) : 0);
      totalGST =
        totalGST + (summaryData[i]?.GST ? Number(summaryData[i]?.GST) : 0);
      totalClaimAmount =
        totalClaimAmount +
        (summaryData[i]?.claimAmount ? Number(summaryData[i]?.claimAmount) : 0);
      totalPaidPerTreasury =
        totalPaidPerTreasury +
        (summaryData[i]?.aba ? Number(summaryData[i]?.claimAmount) : 0);
      totalOutstandingPayable =
        totalOutstandingPayable +
        (summaryData[i]?.aba ? 0 : Number(summaryData[i]?.claimAmount));

      items.push({
        key: summaryData[i]?.id,
        name: summaryData[i]?.name ? summaryData[i]?.name : "-",
        invoice_number: summaryData[i]?.invoice_number
          ? summaryData[i]?.invoice_number
          : "-",
        invoice_date: summaryData[i]?.invoice_date
          ? DDMMYYYYFormat(summaryData[i]?.invoice_date?.split("-"))
          : "-",
        cummulative_claim: summaryData[i]?.cumulativeClaim
          ? summaryData[i]?.cumulativeClaim < 0
            ? `($${formatNumber(
                Math.abs(Number(summaryData[i]?.cumulativeClaim))
              )})`
            : `$${formatNumber(
                Math.abs(Number(summaryData[i]?.cumulativeClaim))
              )}`
          : "$0.00",
        progress_last_month: summaryData[i]?.proUpToLastMonth
          ? summaryData[i]?.proUpToLastMonth < 0
            ? `($${formatNumber(
                Math.abs(Number(summaryData[i]?.proUpToLastMonth))
              )})`
            : `$${formatNumber(
                Math.abs(Number(summaryData[i]?.proUpToLastMonth))
              )}`
          : "$0.00",
        certificate_amount: summaryData[i]?.currentAmount
          ? summaryData[i]?.currentAmount < 0
            ? `($${formatNumber(
                Math.abs(Number(summaryData[i]?.currentAmount))
              )})`
            : `$${formatNumber(
                Math.abs(Number(summaryData[i]?.currentAmount))
              )}`
          : "$0.00",
        payable_amount_ex_gst: summaryData[i]?.beforeGST
          ? summaryData[i]?.beforeGST < 0
            ? `($${formatNumber(Math.abs(Number(summaryData[i]?.beforeGST)))})`
            : `$${formatNumber(Math.abs(Number(summaryData[i]?.beforeGST)))}`
          : "$0.00",
        gst: summaryData[i]?.GST
          ? summaryData[i]?.GST < 0
            ? `($${formatNumber(Math.abs(Number(summaryData[i]?.GST)))})`
            : `$${formatNumber(Math.abs(Number(summaryData[i]?.GST)))}`
          : "$0.00",
        payable_amount: summaryData[i]?.claimAmount
          ? summaryData[i]?.claimAmount < 0
            ? `($${formatNumber(
                Math.abs(Number(summaryData[i]?.claimAmount))
              )})`
            : `$${formatNumber(Math.abs(Number(summaryData[i]?.claimAmount)))}`
          : "$0.00",
        paid_per_treasury: summaryData[i]?.aba
          ? summaryData[i]?.claimAmount < 0
            ? `($${formatNumber(
                Math.abs(Number(summaryData[i]?.claimAmount))
              )})`
            : `$${formatNumber(Math.abs(Number(summaryData[i]?.claimAmount)))}`
          : "$0.00",
        outstanding_payable: summaryData[i]?.aba
          ? "$0.00"
          : summaryData[i]?.claimAmount < 0
          ? `($${formatNumber(Math.abs(Number(summaryData[i]?.claimAmount)))})`
          : `$${formatNumber(Math.abs(Number(summaryData[i]?.claimAmount)))}`,
      });
    }
    items.push({
      // name: <b>Total</b>,
      invoice_number: <b>Total</b>,
      // cummulative_claim: (
      //   <b>
      //     {totalCumulativeClaim
      //       ? `$${formatNumber(totalCumulativeClaim)}`
      //       : "$0.00"}
      //   </b>
      // ),
      // progress_last_month: (
      //   <b>
      //     {totalProUpToLastMonth
      //       ? `$${formatNumber(totalProUpToLastMonth)}`
      //       : "$0.00"}
      //   </b>
      // ),
      certificate_amount: (
        <b>
          {totalCertificateAmount
            ? totalCertificateAmount < 0
              ? `($${formatNumber(Math.abs(Number(totalCertificateAmount)))})`
              : `$${formatNumber(Math.abs(Number(totalCertificateAmount)))}`
            : "$0.00"}
        </b>
      ),
      payable_amount_ex_gst: (
        <b>
          {totalBeforeGST
            ? totalBeforeGST < 0
              ? `($${formatNumber(Math.abs(Number(totalBeforeGST)))})`
              : `$${formatNumber(Math.abs(Number(totalBeforeGST)))}`
            : "$0.00"}
        </b>
      ),
      gst: (
        <b>
          {totalGST
            ? totalGST < 0
              ? `($${formatNumber(Math.abs(Number(totalGST)))})`
              : `$${formatNumber(Math.abs(Number(totalGST)))}`
            : "$0.00"}
        </b>
      ),
      payable_amount: (
        <b>
          {totalClaimAmount
            ? totalClaimAmount < 0
              ? `($${formatNumber(Math.abs(Number(totalClaimAmount)))})`
              : `$${formatNumber(Math.abs(Number(totalClaimAmount)))}`
            : "$0.00"}
        </b>
      ),
      paid_per_treasury: (
        <b>
          {totalPaidPerTreasury
            ? totalPaidPerTreasury < 0
              ? `($${formatNumber(Math.abs(Number(totalPaidPerTreasury)))})`
              : `$${formatNumber(Math.abs(Number(totalPaidPerTreasury)))}`
            : "$0.00"}
        </b>
      ),
      outstanding_payable: (
        <b>
          {totalOutstandingPayable
            ? totalOutstandingPayable < 0
              ? `($${formatNumber(Math.abs(Number(totalOutstandingPayable)))})`
              : `$${formatNumber(Math.abs(Number(totalOutstandingPayable)))}`
            : "$0.00"}
        </b>
      ),
    });
    return items;
  };
  const summaryDatas = summaryDataGenerator(summaryData?.length);

  // const variationTotalColumns = [
  //   {
  //     dataField: "cumulative_claim",
  //     text: "Cumulative Claim(Ex)",
  //   },
  //   {
  //     dataField: "actual_paid",
  //     text: "Actual Paid(Inc)",
  //   },
  //   {
  //     dataField: "outstanding_payable",
  //     text: "Outstanding Payable(Inc)",
  //   },
  //   {
  //     dataField: "work_remaining",
  //     text: "Work Remaining(Inc)",
  //   },
  //   {
  //     dataField: "retention_percentage",
  //     text: "Retention(%)",
  //   },
  //   {
  //     dataField: "retained_amount",
  //     text: "Retained Amount",
  //   },
  // ];
  const variationTotalDatas = [variationDatas[variationDatas?.length - 1]];

  // Transform data into single-column rows
  const transformedData = variationTotalDatas.flatMap((item) => [
    { field: "Cumulative Claim(Ex)", value: item.cumulative_claim },
    { field: "Actual Paid(Inc)", value: item.actual_paid },
    { field: "Outstanding Payable(Inc)", value: item.outstanding_payable },
    { field: "Work Remaining(Inc) (Contract Value - Total Paid)", value: item.work_remaining },
    { field: "Retention(%)", value: item.retention_percentage },
    { field: "Retained Amount", value: item.retained_amount },
  ]);

  const variationTotalColumns = [
    {
      dataField: "field",
      text: "Field",
      style: {
        width: "360px",
      },
      headerStyle: {
        display: "none",
      },
    },
    {
      dataField: "value",
      text: "Value",
      headerStyle: {
        display: "none",
      },
      style: {
        textAlign: "right"
      }
    },
  ];

  return (
    <div>
      {loading && <Spin />}
      {/* <form noValidate className="entry-section">
        <div className="form-box">
          <div className="form-group portion-input">
            <label>Partenship (%)</label>
            <NumberFormat
              type="text"
              name={`portion`}
              value={portionInput ? portionInput : "0%"}
              suffix="%"
              onChange={(e) => setPortionInput(e?.target?.value)}
              onBlur={(e) => handlePortionBlur(e?.target?.value)}
              decimalScale={2}
              allowNegative={false}
              isAllowed={(values) => {
                const { floatValue } = values;
                return !floatValue || floatValue <= 100;
              }}
            />
          </div>
        </div>
      </form> */}
      <h6>
        <strong>Contract Status</strong>
      </h6>
      <BootstrapTable
        keyField="key"
        data={variationDatas.slice(0, -1)}
        columns={variationColumns}
        noDataIndication="No Data Found"
      />

      <div className="total-table-progress-payment">
        <BootstrapTable
          keyField="key"
          data={transformedData}
          columns={variationTotalColumns}
          noDataIndication="No Data Found"
        />
      </div>
      <h6>
        <strong>Contract Summary</strong>
      </h6>
      <div className="contract-summary-table">
        <BootstrapTable
          keyField="key"
          data={summaryDatas}
          columns={summaryDataColumns}
          noDataIndication="No Data Found"
        />
      </div>
    </div>
  );
};

export default ProgressPaymentItem;
